import React from 'react';
import TextSummaryCard from './TextSummaryCard';

interface NotesSummaryCardProps {
  value?: string | null;
  scrollable?: boolean;
}

const NotesSummaryCard: React.FC<NotesSummaryCardProps> = ({ value, scrollable = false }) => (
  <TextSummaryCard
    title="Resumo das observações"
    value={value}
    emptyText="Não há resumo das observações."
    scrollable={scrollable}
  />
);

export default NotesSummaryCard;
